import React, { Component } from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

const API_URL = process.env.REACT_APP_API_URL
class PersonaDetails extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [] };
    }

    async componentDidMount() {
        try {
            const response = await fetch(`${API_URL}/persona/getById/${this.props.id}`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            console.log(data);
            this.setState({ data: data.data });
        } catch (err) {
            console.log(err.message);
        }
    }

    render() {
        var moment = require('moment');
        return (
            <Row className='mb-7'>
                <Form>
                    <Form.Group className='mb-3' controlId='alias' as={Col}>
                        <Form.Label>Alias</Form.Label>
                        <Form.Control required type='text' placeholder='Alias' defaultValue={this.state.data.alias} />
                    </Form.Group>
                    <Row className='mb-3'>
                        <Form.Group controlId='nombre' as={Col}>
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control type='text' placeholder='Nombre' defaultValue={this.state.data.nombre} />
                        </Form.Group>
                        <Form.Group controlId='primerApellido' as={Col}>
                            <Form.Label>Primer Apellido</Form.Label>
                            <Form.Control type='text' placeholder='Primer Apellido' defaultValue={this.state.data.primerApellido} />
                        </Form.Group>
                        <Form.Group controlId='segundoApellido' as={Col}>
                            <Form.Label>Segundo Apellido</Form.Label>
                            <Form.Control type='text' placeholder='Segundo Apellido' defaultValue={this.state.data.segundoApellido} />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group controlId='sexo' as={Col}>
                            <Form.Label>Sexo (asignado al nacer)</Form.Label>
                            <Form.Control type='text' placeholder='Sexo (asignado al nacer)' defaultValue={this.state.data.sexo} />
                        </Form.Group>
                        <Form.Group controlId='orientacionSexual' as={Col}>
                            <Form.Label>Orientación Sexual</Form.Label>
                            <Form.Control type='text' placeholder='Orientación Sexual' defaultValue={this.state.data.orientacionSexual} />
                        </Form.Group>
                        <Form.Group controlId='identidadGenero' as={Col}>
                            <Form.Label>Identidad de Género</Form.Label>
                            <Form.Control type='text' placeholder='Identidad de Género' defaultValue={this.state.data.identidadGenero} />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group controlId='fechaNacimiento' as={Col}>
                            <Form.Label>Fecha de Nacimiento</Form.Label>
                            <Form.Control type='date' placeholder='Fecha de Nacimiento' defaultValue={moment(this.state.data.fechaNacimiento).utc().format('YYYY-MM-DD')} />
                        </Form.Group>
                        <Form.Group controlId='curp' as={Col}>
                            <Form.Label>CURP</Form.Label>
                            <Form.Control type='text' placeholder='CURP' defaultValue={this.state.data.curp} />
                        </Form.Group>
                        <Form.Group controlId='renavi' as={Col}>
                            <Form.Label>RENAVI</Form.Label>
                            <Form.Control type='text' placeholder='RENAVI' defaultValue={this.state.data.renavi} />
                        </Form.Group>
                    </Row>
                    <Row className='mb-3'>
                        <Form.Group controlId='estadoCivil' as={Col}>
                            <Form.Label>Estado Civil</Form.Label>
                            <Form.Control type='text' placeholder='Estado Civil' defaultValue={this.state.data.estadoCivil} />
                        </Form.Group>
                    </Row>
                </Form>
            </Row>
        )
    }

}
export default PersonaDetails;